(function ($) {
    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };
    var apartment_id = getUrlParameter('apartment_id');
    var project_id = getUrlParameter('project_id');
    var wpid = getUrlParameter('wpid');
    var layout = getUrlParameter('layout');
    // setInterval(function(){
    //     viewsCount();
    // }, 60 * 1000);
    // }, 1);

    function viewsCount() {
        const data = {
            'action': 'users',
            'view': '279947140',
            'apartment_id': apartment_id,
            'project_id': project_id,
            'wpid': wpid,
            'layout': layout

        };

        $.get(liven.ajax_url, data, function (response) {
            if (response.success) {
                if(response.data.total) {
                    jQuery("#active-users").html(response.data.total);
                }
            }
        });
    }

})(jQuery);